export default {
  title: 'Automatische monatliche Flyer erhalten',
  status: {
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
  },
  opt_out: {
    on_hint:
      'Ihr FoodAmigos-Tarif enthält 500 kostenlose Flyer pro Monat. Deaktivieren Sie dies, um sie nicht mehr zu erhalten.',
    off_hint: 'Automatische Flyer sind pausiert. Aktivieren Sie sie, um ab dem nächsten monatlichen Lauf fortzufahren.',
    confirm_off: {
      title: 'Automatische Flyer deaktivieren?',
      body: 'Wenn Sie dies deaktivieren, erhält {{location}} ab dem nächsten monatlichen Lauf keine automatischen Flyer mehr. Bestehende Bestellungen sind nicht betroffen.',
      confirm: 'Deaktivieren',
      cancel: 'Aktiviert lassen',
    },
  },
  approved_design: {
    label: 'Freigegebenes Design für monatliche Flyer',
    auto_option: 'Automatisch (zuletzt bestellt)',
    flyer_slot: 'Flyer {{slot}}',
    custom: 'Eigenes',
    untitled: 'Ohne Titel',
    invalid_warning:
      'Das gespeicherte Design ist nicht mehr verfügbar. Bis Sie ein neues auswählen, wird der zuletzt bestellte Flyer verwendet.',
  },
  toasts: {
    failed_to_load: 'Automatische Flyer-Einstellungen konnten nicht geladen werden',
    failed_to_save: 'Änderungen konnten nicht gespeichert werden',
    saved: 'Änderungen gespeichert',
  },
};
